module.exports = __webpack_public_path__ + "media/images/city_img/t_1-b8d354978566a05a67df3783a95b2c5d.png";